import { useEffect } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { Logo } from "./Logo";
import { Footer } from "./Footer";

export const LegalLayout = ({ title, updated, children }) => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-background flex flex-col">
      <header className="border-b border-border bg-white">
        <div className="max-w-4xl mx-auto px-6 lg:px-10 h-20 flex items-center justify-between">
          <Link to="/" data-testid="legal-logo-link"><Logo variant="dark" size={28} /></Link>
          <Link to="/" data-testid="legal-back-link" className="inline-flex items-center gap-2 text-sm font-semibold text-ink hover:text-electric transition-colors">
            <ArrowLeft size={16} /> Volver al inicio
          </Link>
        </div>
      </header>

      <main className="flex-1 max-w-4xl mx-auto w-full px-6 lg:px-10 py-16 lg:py-24">
        <span className="text-xs uppercase tracking-[0.25em] font-bold text-electric">Información legal</span>
        <h1 className="font-heading font-bold text-ink text-4xl sm:text-5xl tracking-tight mt-4">{title}</h1>
        {updated && <p className="text-sm text-muted-foreground mt-3">Última actualización: {updated}</p>}
        <div className="mt-10 space-y-8 legal-content">{children}</div>
      </main>

      <Footer />
    </div>
  );
};

export const LegalBlock = ({ heading, children }) => (
  <section>
    <h2 className="font-heading font-semibold text-ink text-xl mb-3">{heading}</h2>
    <div className="text-muted-foreground leading-relaxed space-y-3">{children}</div>
  </section>
);
